/**
 * Created by Claude on 26.01.2026
 *
 * https://arkadiumsdk.z19.web.core.windows.net/docs/getting-started
 */

const Arkadium = function () {
    Platform.call(this, connector.ARKADIUM, {
        sdk: SdkManager.SDK_ARKADIUM
    });

    connector.social.needWindowForLogin = true;
};

Arkadium.prototype = Object.create(Platform.prototype);
Arkadium.prototype.constructor = Arkadium;

Arkadium.prototype._initialize = function (callback) {
    connector.dataLoader.localStorage = new BucketsLocalStorage(new ArkadiumLocalStorage(), 32);

    callback();
};

Arkadium.prototype._connect = function (callback) {
    ArkadiumSDK.lifecycle.registerEventCallback(ArkadiumSDK.lifecycle.LifecycleEvent.GAME_PAUSE, () => this._toggleSdkPaused(true));
    ArkadiumSDK.lifecycle.registerEventCallback(ArkadiumSDK.lifecycle.LifecycleEvent.GAME_RESUME, () => this._toggleSdkPaused(false));

    if (connector.config.debugMode) {
        ArkadiumSDK.debugMode(true);
    }

    Arkadium.registerInteractEvents();

    callback(connector.STATUS_CONNECTED);
};

Arkadium.INTERACT_EVENT = 3;

Arkadium.registerInteractEvents = function () {
    document.addEventListener("pointerdown", (event) => {
        if (event.target instanceof Element) {
            ArkadiumSDK.lifecycle.dispatchEvent(Arkadium.INTERACT_EVENT, {
                type: "pointerdown",
                x: event.pageX,
                y: event.pageY,
                xPercent: event.pageX / window.innerWidth * 100,
                yPercent: event.pageY / window.innerHeight * 100,
                target: event.target.tagName,
                targetClass: event.target.className,
                targetId: event.target.id
            });
        }
    }, true);

    document.addEventListener("keydown", (event) => {
        ArkadiumSDK.lifecycle.dispatchEvent(Arkadium.INTERACT_EVENT, {
            type: "keydown",
            key: event.key,
            code: event.code
        });
    }, true);
};

Arkadium.prototype.startGame = function (callback) {
    this.whenConnected(() => {
        ArkadiumSDK.lifecycle.onTestReady();

        callback();
    });
};

Arkadium.prototype.getLocalStoragePrefix = function () {
    return "_arkadium";
};

Arkadium.prototype.notifyGameReady = function () {
    this.whenConnected(() => {
        ArkadiumSDK.lifecycle.onGameStart();

        this.bus.trigger("gameReady");
    });
};

Arkadium.prototype.gameplayStart = function (levelNo) {
    this.whenConnected(() => {
        ArkadiumSDK.lifecycle.onLevelStart(levelNo);

        this.bus.trigger("levelStart", levelNo);
    });
};

Arkadium.prototype.gameplayStop = function (levelNo) {
    this.whenConnected(() => {
        ArkadiumSDK.lifecycle.onLevelEnd(levelNo);

        this.bus.trigger("levelEnd", levelNo);
    });
};
